module.exports = __webpack_public_path__ + "static/media/ic-play-store.ef8f716b.webp";